export const translations = {
  es: {
    appName: "Appomax",
    company: "La Paz Internacional, S.A.",
    login: "Iniciar sesión",
    logout: "Cerrar sesión",
    email: "Correo electrónico",
    password: "Contraseña",
    signIn: "Entrar",
    catalog: "Catálogo",
    admin: "Administración",
    search: "Buscar productos...",
    all: "Todos",
    calzado: "Calzado",
    ropa: "Ropa",
    accesorios: "Accesorios",
    filters: "Filtros",
    size: "Talla",
    price: "Precio",
    priceRange: "Rango de precio",
    onlyFavorites: "Solo favoritos",
    clearFilters: "Limpiar filtros",
    outOfStock: "Fuera de Stock",
    inStock: "Disponible",
    tapToZoom: "Toca para ampliar",
    packaging: "Detalles de empaque",
    unitsPerBox: "Unidades por caja",
    weight: "Peso",
    dimensions: "Dimensiones",
    sizes: "Tallas disponibles",
    selectSize: "Selecciona una talla",
    quantity: "Cantidad",
    addToOrder: "Agregar al pedido",
    order: "Pedido",
    orderSummary: "Resumen del pedido",
    empty: "Tu pedido está vacío",
    subtotal: "Subtotal",
    total: "Total",
    additionalInfo: "Información adicional",
    additionalInfoPh: "Notas para el equipo de ventas (opcional)",
    customerInfo: "Información del cliente",
    customerInfoPh: "Nombre / referencia del cliente (opcional)",
    confirmOrder: "Confirmar y enviar pedido",
    orderSent: "Pedido enviado por correo al vendedor y al equipo de ventas",
    remove: "Quitar",
    favorites: "Favoritos",
    noProducts: "No se encontraron productos",
    // admin
    dashboard: "Panel",
    users: "Usuarios",
    products: "Productos",
    orders: "Pedidos",
    categories: "Categorías",
    sizesTab: "Tallas",
    totalOrders: "Pedidos totales",
    pendingOrders: "Pedidos pendientes",
    totalSales: "Ventas totales",
    addProduct: "Agregar producto",
    editProduct: "Editar producto",
    addUser: "Agregar usuario",
    name: "Nombre",
    role: "Rol",
    stock: "Stock",
    markOutOfStock: "Fuera de stock",
    description: "Descripción",
    category: "Categoría",
    uploadPhoto: "Subir foto",
    photosHint: "Arrastra las miniaturas para reordenar. La primera foto es la principal.",
    mainPhoto: "Principal",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    status: "Estado",
    pendiente: "Pendiente",
    procesado: "Procesado",
    enviado: "Enviado",
    seller: "Vendedor",
    date: "Fecha",
    actions: "Acciones",
    addCategory: "Agregar categoría",
    addSize: "Agregar talla",
    label: "Etiqueta",
    group: "Grupo",
    backToCatalog: "Volver al catálogo",
    viewDetails: "Ver detalles",
    confirmDelete: "¿Eliminar este elemento?",
    nameEs: "Nombre (ES)",
    nameEn: "Nombre (EN)",
    descEs: "Descripción (ES)",
    descEn: "Descripción (EN)",
    orderDetails: "Detalle del pedido",
    notes: "Notas",
    saved: "Guardado correctamente",
    deleted: "Eliminado",
    landingAnnounce: "Catálogo mayorista B2B · Arma pedidos al instante",
    enter: "Ingresar",
    heroKicker: "Sala de ventas digital",
    heroTitle: "La colección completa, en una sola pantalla",
    heroSubtitle: "Explora calzado, ropa y accesorios de La Paz Internacional y arma pedidos en segundos.",
    exploreCatalog: "Explorar catálogo",
    shopByCategory: "Compra por categoría",
    featuredTitle: "Destacados",
    viewAll: "Ver todo",
    whyTitle: "Diseñado para tu sala de ventas",
    val1t: "Catálogo completo",
    val1d: "Fotos, tallas y detalles de empaque en cada producto.",
    val2t: "Pedidos por correo",
    val2d: "El pedido llega al vendedor y al equipo de ventas.",
    val3t: "Español e inglés",
    val3d: "Cambia de idioma con un solo toque.",
    val4t: "Optimizado táctil",
    val4d: "Pensado para kiosco, sin teclado físico.",
    bannerTitle: "Listo para vender",
    bannerText: "Ingresa y comienza a crear pedidos ahora mismo.",
    footerTagline: "Distribución mayorista de calzado, ropa y accesorios.",
    footerRights: "Todos los derechos reservados.",
  },
  en: {
    appName: "Appomax",
    company: "La Paz Internacional, S.A.",
    login: "Sign in",
    logout: "Log out",
    email: "Email",
    password: "Password",
    signIn: "Enter",
    catalog: "Catalog",
    admin: "Administration",
    search: "Search products...",
    all: "All",
    calzado: "Footwear",
    ropa: "Apparel",
    accesorios: "Accessories",
    filters: "Filters",
    size: "Size",
    price: "Price",
    priceRange: "Price range",
    onlyFavorites: "Favorites only",
    clearFilters: "Clear filters",
    outOfStock: "Out of Stock",
    inStock: "Available",
    tapToZoom: "Tap to zoom",
    packaging: "Packaging details",
    unitsPerBox: "Units per box",
    weight: "Weight",
    dimensions: "Dimensions",
    sizes: "Available sizes",
    selectSize: "Select a size",
    quantity: "Quantity",
    addToOrder: "Add to order",
    order: "Order",
    orderSummary: "Order summary",
    empty: "Your order is empty",
    subtotal: "Subtotal",
    total: "Total",
    additionalInfo: "Additional information",
    additionalInfoPh: "Notes for the sales team (optional)",
    customerInfo: "Customer information",
    customerInfoPh: "Customer name / reference (optional)",
    confirmOrder: "Confirm and send order",
    orderSent: "Order emailed to the seller and sales team",
    remove: "Remove",
    favorites: "Favorites",
    noProducts: "No products found",
    dashboard: "Dashboard",
    users: "Users",
    products: "Products",
    orders: "Orders",
    categories: "Categories",
    sizesTab: "Sizes",
    totalOrders: "Total orders",
    pendingOrders: "Pending orders",
    totalSales: "Total sales",
    addProduct: "Add product",
    editProduct: "Edit product",
    addUser: "Add user",
    name: "Name",
    role: "Role",
    stock: "Stock",
    markOutOfStock: "Out of stock",
    description: "Description",
    category: "Category",
    uploadPhoto: "Upload photo",
    photosHint: "Drag thumbnails to reorder. The first photo is the main one.",
    mainPhoto: "Main",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    status: "Status",
    pendiente: "Pending",
    procesado: "Processed",
    enviado: "Shipped",
    seller: "Seller",
    date: "Date",
    actions: "Actions",
    addCategory: "Add category",
    addSize: "Add size",
    label: "Label",
    group: "Group",
    backToCatalog: "Back to catalog",
    viewDetails: "View details",
    confirmDelete: "Delete this item?",
    nameEs: "Name (ES)",
    nameEn: "Name (EN)",
    descEs: "Description (ES)",
    descEn: "Description (EN)",
    orderDetails: "Order details",
    notes: "Notes",
    saved: "Saved successfully",
    deleted: "Deleted",
    landingAnnounce: "B2B wholesale catalog · Build orders instantly",
    enter: "Sign in",
    heroKicker: "Digital sales floor",
    heroTitle: "The full collection, on a single screen",
    heroSubtitle: "Browse footwear, apparel and accessories from La Paz Internacional and build orders in seconds.",
    exploreCatalog: "Explore catalog",
    shopByCategory: "Shop by category",
    featuredTitle: "Featured",
    viewAll: "View all",
    whyTitle: "Built for your sales floor",
    val1t: "Full catalog",
    val1d: "Photos, sizes and packaging details on every product.",
    val2t: "Email orders",
    val2d: "Orders reach the seller and the sales team.",
    val3t: "Spanish & English",
    val3d: "Switch language with a single tap.",
    val4t: "Touch optimized",
    val4d: "Designed for kiosk use, no physical keyboard.",
    bannerTitle: "Ready to sell",
    bannerText: "Sign in and start building orders right now.",
    footerTagline: "Wholesale distribution of footwear, apparel and accessories.",
    footerRights: "All rights reserved.",
  },
};
